<template>
  <b-container fluid class="pb-4">
     <!-- 工程内在庫 -->
    <h1 class="fc-h1">{{this.$i18n.t('ngrate.title')}}</h1>
    <form>
      <div class="w-100 mb-3">
        <b-card>
          <form>
            <!-- 日時 -->
            <b-form-group
              id="select_date"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('ngrate.label_date')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
                <div class="flex-fill">
                  <b-form-input id="from" v-model="from" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="fromTime" v-model="fromTime" type="time"></b-form-input>
                </div>
                <div class="flex-shrink-1 px-2">-</div>
                <div class="flex-fill">
                  <b-form-input id="to" v-model="to" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="toTime" v-model="toTime" type="time"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <!-- 型番 -->
            <b-form-group
              id="code"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('ngrate.label_code')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="selectedCode" :options="codes" class="mb-3"></b-form-select>
            </b-form-group>
            <!-- ライン -->
            <b-form-group
              id="line"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('ngrate.label_line')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="selectedLine" :options="lines" class="mb-3"></b-form-select>
            </b-form-group>
            <div>
            <!-- 稼働計画番号 -->
            <b-form-group
              id="moSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('ngrate.label_mo')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="moSearch" :placeholder="this.$i18n.t('ngrate.placeholder_mo')"></b-form-input>
            </b-form-group>
              <!-- 検索 -->
              <b-button variant="primary" @click="search" class="float-right px-5">{{this.$i18n.t('ngrate.button_search')}}</b-button>
            </div>
          </form>
        </b-card>
      </div>
    </form>
    <div v-if="isSearch">
        <b-card class="mb-3">
          <!-- 工程別不良率 -->
          <h2
            :class="showCollapse ? 'collapsed' : null"
            :aria-expanded="showCollapse ? 'true' : 'false'"
            aria-controls="collapse-12"
            @click="showCollapse = !showCollapse"
          >{{this.$i18n.t('ngrate.label_ng_process')}}</h2>
          <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
            <b-pagination
              v-model="procCurrentPage"
              :total-rows="procTotalRows"
              :per-page="procPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
            <b-table
              :striped="striped"
              :bordered="bordered"
              :borderless="borderless"
              :outlined="outlined"
              :current-page="procCurrentPage"
              :per-page="procPerPage"
              :small="small"
              :hover="hover"
              :dark="dark"
              :fixed="fixed"
              :foot-clone="footClone"
              :no-border-collapse="noCollapse"
              :items="items"
              :fields="fields"
              :head-variant="headVariant"
              :table-variant="tableVariant"
            >
            <template v-slot:cell(processName)="row">
              <u>
                <b-link
                  @click="machineSearch(row.item.processId)"
                  :class="showCollapse ? 'collapsed' : null"
                  :aria-expanded="showCollapse ? 'true' : 'false'"
                  aria-controls="collapse-12"
                >{{ row.item.processName }}</b-link>
              </u>
            </template>
            </b-table>
            <!-- CSV出力 -->
            <b-button variant="primary" @click="processCsv" class="float-right">{{this.$i18n.t('result.button_csv')}}</b-button>
          </b-collapse>
        </b-card>
          <div v-if="isDispLine">
            <b-card class="mb-3">
              <!-- 設備別不良率 -->
            <h2
              :class="showMachineCollapse ? 'collapsed' : null"
              :aria-expanded="showMachineCollapse ? 'true' : 'false'"
              aria-controls="collapse-12"
              @click="showMachineCollapse = !showMachineCollapse"
            >{{this.$i18n.t('ngrate.label_ng_machine')}}</h2>
            <b-collapse id="collapse-12" v-model="showMachineCollapse" class="mt-3">
            <b-pagination
              v-model="machineCurrentPage"
              :total-rows="machineTotalRows"
              :per-page="machinePerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
              <b-table
                :striped="striped"
                :bordered="bordered"
                :borderless="borderless"
                :outlined="outlined"
                :current-page="machineCurrentPage"
                :per-page="machinePerPage"
                :small="small"
                :hover="hover"
                :dark="dark"
                :fixed="fixed"
                :foot-clone="footClone"
                :no-border-collapse="noCollapse"
                :items="machineItems"
                :fields="machineFields"
                :head-variant="headVariant"
                :table-variant="tableVariant"
              >
              </b-table>
              <!-- CSV出力 -->
              <b-button variant="primary" @click="machineCsv" class="float-right">{{this.$i18n.t('result.button_csv')}}</b-button>
            </b-collapse>
            </b-card>
        </div>
    </div>
    <!-- エラーメッセージ用 -->
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      pageOptions: [10, 20, 50, 100],
      serialPerPage: 10,
      serialTotalRows: 1,
      serialCurrentPage: 1,
      selectedCode: null,
      selectedLine: null,
      moSearch: null,
      procCurrentPage: 1,
      procPerPage: 5,
      procTotalRows: 1,
      machineCurrentPage: 1,
      machinePerPage: 5,
      machineTotalRows: 1,
      codes: [
        { value: null, text: this.$i18n.t('ngrate.label_all_code') }
      ],
      lines: [
        { value: null, text: this.$i18n.t('ngrate.label_all_line') }
      ],
      fields: [
        { key: 'processName', label: this.$i18n.t('ngrate.label_process'), sortable: true },
        { key: 'passCount', label: this.$i18n.t('ngrate.label_make_count'), sortable: true },
        { key: 'ngCount', label: this.$i18n.t('ngrate.label_ng_count'), sortable: true },
        { key: 'dispNgRate', label: this.$i18n.t('ngrate.label_ng_rate'), sortable: true }
      ],
      machineFields: [
        { key: 'machineName', label: this.$i18n.t('ngrate.label_machine'), sortable: true },
        { key: 'passCount', label: this.$i18n.t('ngrate.label_make_count'), sortable: true },
        { key: 'ngCount', label: this.$i18n.t('ngrate.label_ng_count'), sortable: true },
        { key: 'dispNgRate', label: this.$i18n.t('ngrate.label_ng_rate'), sortable: true }
      ],
      items: [],
      machineItems: [],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      showCollapse: true,
      showMachineCollapse: true,
      noCollapse: true,
      isSearch: false,
      isDispLine: false,
      from: '',
      to: '',
      fromTime: '',
      defFromTime: '',
      toTime: '',
      defToTime: '',
      startForSearched: null,
      endForSearched: null,
      codeForSearched: '',
      revForSearched: '',
      lineForSearched: '',
      moForSearched: '',
      errMsg: null,
      errSbj: null
    }
  },
  async created () {
    // 日付取得
    var dates = await this.getDates()
    this.from = window.formatDate(dates.start, 'yyyy-MM-dd')
    this.to = window.formatDate(dates.end, 'yyyy-MM-dd')
    this.fromTime = window.formatDate(dates.start, 'HH:mm')
    this.defFromTime = this.fromTime
    this.toTime = window.formatDate(dates.end, 'HH:mm')
    this.defToTime = this.toTime

    // 型番取得
    this.searchProductinfo()
    // ライン取得
    this.searchLine()
  },
  mounted () {
    // Set the initial number of items
    this.procTotalRows = this.items.length
    this.machineTotalRows = this.machineItems.length
  },
  methods: {
    // 検索アクション
    search: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      var body = {}
      // 日付
      if (this.from === '' && this.to === '') {
        this.errSbj = this.$i18n.t('ngrate.title')
        this.errMsg = this.$i18n.t('ngrate.err_day_hissu')
        this.$bvModal.show('md-err')
        return
      }
      var startDate = ''
      if (this.from !== '') {
        var from = ''
        if (this.fromTime !== '') {
          from = this.$moment(this.from + ' ' + this.fromTime, 'YYYY-MM-DD HH:mm:00')
        } else {
          from = this.$moment(this.from + ' ' + this.defFromTime, 'YYYY-MM-DD HH:mm:00')
        }
        startDate = from.utc().format('YYYY-MM-DD HH:mm:ss')
        body.start = startDate
      }

      var endDate = ''
      if (this.to !== '') {
        var to = ''
        if (this.toTime !== '') {
          to = this.$moment(this.to + ' ' + this.toTime, 'YYYY-MM-DD HH:mm:00')
        } else {
          to = this.$moment(this.to + ' ' + this.defToTime, 'YYYY-MM-DD HH:mm:00')
        }
        endDate = to.utc().format('YYYY-MM-DD HH:mm:ss')
        body.end = endDate
      }

      // 日付論理チェック
      var cmpFrom = new Date(startDate)
      var cmpTo = new Date(endDate)
      if (cmpFrom.getTime() > cmpTo.getTime()) {
        this.errSbj = this.$i18n.t('ngrate.title')
        this.errMsg = this.$i18n.t('ngrate.err_from_to_reverse')
        this.$bvModal.show('md-err')
        return
      }

      // 型番
      var selected = []
      selected[0] = null
      selected[1] = null
      if (this.selectedCode !== null) {
        selected = this.selectedCode.split(',')
      }
      body.code = selected[0]
      body.rev = selected[1]

      // ライン
      if (this.selectedLine !== null) {
        body.line = String(this.selectedLine)
        // ラインが指定された場合のみ検索用に保持
        this.lineForSearched = String(this.selectedLine)
      } else {
        this.lineForSearched = ''
      }

      // 稼働計画番号
      body.mo = this.moSearch

      // 設備別不良率取得用に入力された値を保持しておく
      this.startForSearched = startDate
      this.endForSearched = endDate
      this.codeForSearched = selected[0]
      this.revForSearched = selected[1]
      this.moForSearched = this.moSearch

      // ライン内在庫取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/quality/ngRate/selectByProcess', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var ngRateByProcessInfoList = res.data.ngRateByProcessInfo
            var items = []
            if (ngRateByProcessInfoList.length === 0) {
              this.isSearch = false
              this.isDispLine = false
              this.showCollapse = false
              this.showMachineCollapse = false
              this.errSbj = this.$i18n.t('ngrate.title')
              this.errMsg = this.$i18n.t('ngrate.err_not_serial')
              this.$bvModal.show('md-err')
              return
            }

            // 整形
            for (var i = 0; i < ngRateByProcessInfoList.length; i++) {
              var item = {}
              item.processId = ngRateByProcessInfoList[i].process_id
              item.processName = ngRateByProcessInfoList[i].process_name
              item.passCount = ngRateByProcessInfoList[i].pass_count
              item.ngCount = ngRateByProcessInfoList[i].ng_count
              item.ngRate = Math.floor(ngRateByProcessInfoList[i].ng_rate)
              item.dispNgRate = item.ngRate.toLocaleString()
              items.push(item)
            }
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...items)
            // ページング設定
            this.procTotalRows = this.items.length

            this.isSearch = true
            this.isDispLine = false
            this.showCollapse = true
            this.showMachineCollapse = true
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })
    },
    searchProductinfo: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.code = ''
      body.codeLikeFlg = ''
      body.rev = ''
      body.revLikeFlg = ''
      body.petname = ''
      body.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true

      this.$axios
        .post(window.END_POINT + '/master/productinfo/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var modelList = res.data.productInfo
            var codes = []

            // 整形
            for (var i = 0; i < modelList.length; i++) {
              var code = {}
              code.value = modelList[i].code + ',' + modelList[i].rev + ',' + modelList[i].petname
              code.text = modelList[i].code + ' - ' + modelList[i].rev + ' - ' + modelList[i].petname
              codes.push(code)
            }
            // 一旦データクリア
            this.codes.splice(1)
            // データセット
            this.codes.splice(1, 0, ...codes)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchLine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.lineId = ''
      body.lineIdLikeFlg = ''
      body.lineName = ''
      body.base = ''
      body.lineKind = ''
      body.efFlg = ''

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true

      this.$axios
        .post(window.END_POINT + '/master/line/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineInfoList = res.data.lineInfo
            var lines = []

            // 整形
            for (var i = 0; i < lineInfoList.length; i++) {
              var line = {}
              line.value = lineInfoList[i].line_id
              line.text = lineInfoList[i].line_name
              lines.push(line)
            }
            // 一旦データクリア
            this.lines.splice(1)
            // データセット
            this.lines.splice(1, 0, ...lines)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // 工程名リンククリックアクション
    machineSearch: function (processId) {
      this.isDispLine = true
      this.showCollapse = true
      this.showMachineCollapse = true

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.start = this.startForSearched
      body.end = this.endForSearched
      body.code = this.codeForSearched
      body.rev = this.revForSearched
      body.line = this.lineForSearched
      body.process = String(processId)
      body.mo = this.moForSearched

      // 工程内在庫取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/quality/ngRate/selectByMachine', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var ngRateByMachineInfoList = res.data.ngRateByMachineInfo
            var machineItems = []

            // 整形
            for (var i = 0; i < ngRateByMachineInfoList.length; i++) {
              var machineItem = {}
              machineItem.machineId = ngRateByMachineInfoList[i].machine_id
              machineItem.machineName = ngRateByMachineInfoList[i].machine_name
              machineItem.passCount = ngRateByMachineInfoList[i].pass_count
              machineItem.ngCount = ngRateByMachineInfoList[i].ng_count
              machineItem.ngRate = Math.floor(ngRateByMachineInfoList[i].ng_rate)
              machineItem.dispNgRate = machineItem.ngRate.toLocaleString()
              machineItems.push(machineItem)
            }
            // 一旦データクリア
            this.machineItems.splice(0)
            // データセット
            this.machineItems.splice(0, 0, ...machineItems)
            // ページング設定
            this.machineTotalRows = this.machineItems.length
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })
    },
    // CSV出力(工程別)
    processCsv: function () {
      // タイトル設定
      var title = []
      this.fields.forEach(el => {
        title.push('"' + el['label'] + '"')
      })
      var csv = title.join(',')
      csv += '\r\n'
      // データ設定
      var data = []
      this.items.forEach(el => {
        data = []
        data.push('"' + el['processName'] + '"')
        data.push('"' + el['passCount'] + '"')
        data.push('"' + el['ngCount'] + '"')
        data.push('"' + el['ngRate'] + '"')
        csv += data.join(',')
        csv += '\r\n'
      })
      // CSVダウンロード
      window.downloadCsv(csv, 'NgRateByProcess')
    },
    // CSV出力(設備別)
    machineCsv: function () {
      // タイトル設定
      var title = []
      this.machineFields.forEach(el => {
        title.push('"' + el['label'] + '"')
      })
      var csv = title.join(',')
      csv += '\r\n'
      // データ設定
      var data = []
      this.machineItems.forEach(el => {
        data = []
        data.push('"' + el['machineName'] + '"')
        data.push('"' + el['passCount'] + '"')
        data.push('"' + el['ngCount'] + '"')
        data.push('"' + el['ngRate'] + '"')
        csv += data.join(',')
        csv += '\r\n'
      })
      // CSVダウンロード
      window.downloadCsv(csv, 'NgRateByMachine')
    },
    getDates: async function () {
      var startTime = ''
      var dates = []
      // 開始時間取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      await this.$axios
        .post(window.END_POINT + '/common/selectStartTime', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            startTime = res.data.shift_start_time
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })

      // 日またぎ確認、時間取得
      var nowTime = window.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      dates = window.getStartTime(startTime, nowTime, false)

      return dates
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    calteFromOtherPage: function (serial) {
      var path = '/calte'
      this.$router.push({ path: path, query: {serial: [serial]} })
    }
  }
}
</script>

<style scoped>
.fc-triangle-r {
  content: "";
  border-left: 1rem solid rgba(255, 255, 255, 0.5);
  border-top: 1rem solid transparent;
  border-bottom: 1rem solid transparent;
  position: absolute;
  top: 1rem;
  left: -0.5rem;
  width: 0;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NgRate.vue